import Radium from '@flipdish/radium';
import { debounce } from 'lodash';
import * as Raven from 'raven-js';
import * as React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as Actions from '../../actions/Actions';
import { AddLocation, LoadDeliveryLocations } from '../../actions/Actions';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import { PageTitle, SectionHeader, SectionHeaderIcon, Icon, SectionHeaderText } from '../../../ui';
import { MainLayout } from '../MainLayout/MainLayout';
import { FixedBottomContainer } from '../FixedBottomContainer/FixedBottomContainer';

const tinycolor = require('tinycolor2');

interface DispatchProps {
  AddLocation: (location: Api.Geo, certainty: Store.LocationCertainty) => any;
  LoadDeliveryLocations: () => any;
  SaveAddressSuggestion: (suggestion: string, postalCode: any) => any;
}

interface StateProps {
  Config: Data.Config;
  AppConfig: Data.Async<Api.AppConfig>;
  Location: Api.Geo;
  addressSuggestion: {};
  translate: any;
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
}

type Props = DispatchProps & StateProps;

interface State {
  suggestions: google.maps.places.AutocompletePrediction[];
  selected: google.maps.places.AutocompletePrediction | null;
  places: google.maps.places.PlacesService | null;
  place?: google.maps.places.PlaceResult;
  instructions: string;
  submitting: boolean;
}

// Get the input string from a HTML input event
const targetInput = function(e: React.FormEvent<React.Component<any, any>>): string {
  const input = (e.target as any).value;
  return input as string;
};

export class NewLocation extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);
    this.state = {
      places: null,
      selected: null,
      suggestions: [],
      instructions: '',
      submitting: false
    };
  }

  public componentDidMount() {
    Utilities.ensureVisible(findDOMNode(this));
    this.props.Config.MapLoader.then(() => {
      this.setState({
        places: new google.maps.places.PlacesService(document.createElement('div'))
      });
    });
  }

  public addressKeyPress = (target: React.KeyboardEvent<React.Component<any, any>>) => {
    alert('Enter');
    // Handle Enter
    if (target.charCode === 13) {
      this.handleConfirmAddress();
    }
  };

  public handlePlaceSelected = (locations: google.maps.places.AutocompletePrediction[]) => {
    console.log('user selected', locations);

    const { places } = this.state;

    if (!locations || locations.length === 0 || !places) {
      return;
    }

    const selected = locations[0];

    const request: any = {
      placeId: selected.place_id,
      fields: ['geometry', 'address_component']
    };

    places.getDetails(request, (result, status) => {
      switch (status) {
        case google.maps.places.PlacesServiceStatus.OK:
          break;

        default:
          let appconfig: any = {};

          if (this.props.AppConfig.status === 'success') {
            appconfig.AppNameId = this.props.AppConfig.data.AppNameId;
            appconfig.WhiteLabelId = this.props.AppConfig.data.WhiteLabelId;
          }

          Raven.captureMessage('Error calling Google Maps Place Details', {
            tags: { category: 'Third party library failure' },
            extra: {
              result: result,
              status: status,
              locations: locations,
              appconfig: appconfig
            }
          });
          return;
      }

      this.props.AddLocation(Data.ToGeo(result.geometry.location), Store.LocationCertainty.User);
      this.setState({ place: result });
    });

    this.setState({
      selected: locations[0]
    });
  };

  public handleInputChange = debounce((input: string) => {
    if (input.length < 5) {
      // Don't sent input with length less than 5 to the geocode API.
      return;
    }

    this.props.Config.MapLoader.then((tools) => {
      const { AppConfig } = this.props;
      let bounds: google.maps.LatLngBoundsLiteral | undefined;
      if (AppConfig.status === 'success') {
        const { data } = AppConfig;
        bounds = {
          // North East : bigger
          // South West : smaller
          north: data.MapBoundryMaxLatitude,
          south: data.MapBoundryMinLatitude,
          east: data.MapBoundryMaxLongitude,
          west: data.MapBoundryMinLongitude
        };
      }

      console.log(this.props.Location);
      console.log({
        input,
        location: Data.LatLng(this.props.Location),
        radius: 200, // TODO: tweak 200m?
        bounds
      });

      tools.AutoComplete.getPlacePredictions(
        {
          input,
          location: Data.LatLng(this.props.Location),
          radius: 200, // TODO: tweak 200m?
          bounds
        },
        (suggestions: google.maps.places.AutocompletePrediction[], status: any) => {
          switch (status) {
            case google.maps.places.PlacesServiceStatus.OK:
              break;

            default:
              let appconfig: any = {};

              if (this.props.AppConfig.status === 'success') {
                appconfig.AppNameId = this.props.AppConfig.data.AppNameId;
                appconfig.WhiteLabelId = this.props.AppConfig.data.WhiteLabelId;
              }

              Raven.captureMessage('Error getting Google Maps Places predictions', {
                tags: { category: 'Third party library failure' },
                extra: {
                  input: input,
                  status: status,
                  appconfig: appconfig
                }
              });
              return;
          }

          if (suggestions) {
            // suggestions can be null if given invalid input.
            // The <Typeahead> component cannot deal with null.
            this.setState({ suggestions });
          }
        }
      );
    });
  }, 250);

  public handleDeliveryInstructionsEdit = (e: React.FormEvent<React.Component<any, any>>) => {
    this.setState({
      instructions: targetInput(e)
    });
  };

  public handleConfirmAddress = () => {
    const { place, selected } = this.state;
    console.log('this.state ', this.state);
    if (!place) {
      return;
    }
    const addressComponents = place.address_components;
    let postalCode;
    for (const addressComponent of addressComponents) {
      if (addressComponent.types[0] === 'postal_code') {
        postalCode = addressComponent.long_name;
      }
    }

    if (!selected || !place) {
      let appconfig: any = {};

      if (this.props.AppConfig.status === 'success') {
        appconfig.AppNameId = this.props.AppConfig.data.AppNameId;
        appconfig.WhiteLabelId = this.props.AppConfig.data.WhiteLabelId;
      }

      Raven.captureMessage('Selected address is null', {
        tags: { category: 'Frontend error' },
        extra: {
          appconfig: appconfig
        }
      });
      return;
    }

    this.props.SaveAddressSuggestion(selected.description, postalCode);

    /*if (this.props.Location.Latitude && this.props.Location.Longitude) {
      NavigateTo(
        `#/delivery/custom/${this.props.Location.Latitude}/${
          this.props.Location.Longitude
        }`
      );
    } else {*/
    Utilities.navigateTo(
      '#/delivery/confirm/' + this.props.Location.Latitude + '/' + this.props.Location.Longitude
    );
    /*}*/

    //this.props.SaveAddressSuggestion(selected.description, postalCode);
  };

  public locationIsValid = (): boolean => {
    const { selected, place } = this.state;
    return selected != null && place != null;
  };

  public render(): JSX.Element {
    const { translate, AppDesignScheme, isDark } = this.props;

    const { submitting, suggestions } = this.state;

    const disabled = submitting || !this.locationIsValid();

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      subheader: {
        borderColor: AppDesignScheme.Secondary,
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString()
      },
      darkSubheader: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        backgroundColor: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary).darken(10)}`
      },
      nav: {
        ':hover': {},
        ':active': {}
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {}
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      }
    };

    return (
      <MainLayout xsPaddingBottom="60px" smPaddingBottom="60px">
        <div className="container-fluid flex flex-column">
          <div className="container flex-one xs-full-width">
            <div className="row delivery">
              <div className="col-md-12">
                <div style={{ marginTop: '20px' }} />
                <Link to="/delivery">
                  <div
                    key="fd-nav"
                    className="fd-nav flex flex-align-center"
                    style={styles.nav as any}
                  >
                    <i
                      className="arrow_carrot-left tertiary"
                      aria-hidden="true"
                      style={
                        Radium.getState(this.state, 'fd-nav', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'fd-nav', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    />
                    <p
                      className="inline-block clear-margins tertiary bold"
                      style={
                        Radium.getState(this.state, 'fd-nav', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'fd-nav', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    >
                      <u>{translate('Select_a_different_location')}</u>
                    </p>
                  </div>
                </Link>
              </div>
              <div className="col-md-8 col-lg-8 col-sm-12">
                <SectionHeader>
                  <SectionHeaderIcon>
                    <Icon fontSize="large" aria-hidden color="inherit" className="ei icon_pin" />
                  </SectionHeaderIcon>

                  <SectionHeaderText
                    id="skip-to-content"
                    title={translate('Delivery')}
                    subTitle={translate('Enter_the_address')}
                  />
                </SectionHeader>

                <label
                  htmlFor="enterDeliveryAddress"
                  className="tertiary bold"
                  style={isDark ? styles.primary : styles.tertiary}
                >
                  {translate('Enter_an_address_for_delivery')}
                </label>
                <FormGroup>
                  <div className="min-md-flex">
                    <Typeahead
                      inputProps={{
                        id: 'enterDeliveryAddress',
                        autoFocus: true,
                        'aria-label': `${translate('Enter_an_address_for_delivery')}`
                      }}
                      className="flex-one fd-typeahead"
                      labelKey="description"
                      onChange={this.handlePlaceSelected}
                      onKeyPress={this.addressKeyPress}
                      onInputChange={this.handleInputChange}
                      options={suggestions}
                      placeholder={translate('Enter_your_address_here')}
                      emptyLabel={translate('Enter_your_address_here')}
                      filterBy={() => {
                        return true;
                      }}
                      data-fd="delivery-typeahead"
                    />
                    <button
                      className="fd-button fd-button--small fd-button--secondary hidden-xs hidden-sm"
                      disabled={disabled}
                      onClick={this.handleConfirmAddress}
                      key="next-button"
                      style={
                        [
                          styles.buttonSecondary,
                          Radium.getState(this.state, 'next-button', ':active')
                            ? styles.buttonActive
                            : Radium.getState(this.state, 'next-button', ':hover')
                            ? styles.buttonHover
                            : null
                        ] as any
                      }
                    >
                      <p className="clear-margins primary fd-h4" style={styles.primary}>
                        {translate('Next')}
                      </p>
                    </button>
                  </div>
                </FormGroup>
                <Link to="/delivery/map">
                  <div
                    key="address-unlisted"
                    className="fd-nav flex flex-align-center"
                    style={styles.nav as any}
                  >
                    <i
                      className="icon_pin secondary"
                      aria-hidden="true"
                      style={
                        Radium.getState(this.state, 'address-unlisted', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'address-unlisted', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.secondary
                      }
                    />
                    <p
                      className="inline-block clear-margins secondary bold fd-h4"
                      style={
                        Radium.getState(this.state, 'address-unlisted', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'address-unlisted', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.secondary
                      }
                    >
                      <u>{translate('My_address_is_not_listed')}</u>
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <FixedBottomContainer fixedOnly={['xs', 'sm']}>
            <button
              className={`fd-button fd-button--bottom fd-button--secondary visible-xs-block visible-sm-block ${
                Utilities.isIOS || Utilities.extraOption('data-full-screen-on-mobile') === 'false'
                  ? 'fd-button--bottom-ios'
                  : ''
              }`}
              disabled={disabled}
              onClick={this.handleConfirmAddress}
              key="next-button-bottom"
              style={
                [
                  styles.buttonSecondary,
                  Radium.getState(this.state, 'next-button-bottom', ':active')
                    ? styles.buttonActive
                    : Radium.getState(this.state, 'next-button-bottom', ':hover')
                    ? styles.buttonHover
                    : null
                ] as any
              }
            >
              <p className="clear-margins primary fd-h4" style={styles.primary}>
                {translate('Next')}
              </p>
            </button>
          </FixedBottomContainer>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state: Store.State): StateProps => {
  return {
    Config: state.flipdish.Config,
    AppConfig: state.flipdish.AppConfig,
    Location: state.flipdish.Location.geo,
    addressSuggestion: state.flipdish.addressSuggestion,
    translate: getTranslate(state.locale),
    AppDesignScheme: state.appDesignScheme,
    isDark: state.flipdish.isDark
  };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
    AddLocation: (location: Api.Geo, certainty: Store.LocationCertainty) => {
      dispatch(AddLocation(location, certainty));
    },

    LoadDeliveryLocations: () => {
      dispatch(LoadDeliveryLocations());
    },
    SaveAddressSuggestion: (suggestion: string, postalCode: any) => {
      console.log('suggestion', suggestion);
      dispatch(Actions.SaveAddressSuggestion(suggestion, postalCode));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(NewLocation));
